export default __webpack_public_path__ + "static/media/daily-payment-summary.6a96cae8.svg";